export const getComplaintTypeFrag = `
    id
    name
    active
    daysToProcess
    serviceId
`;
